module.exports = __webpack_public_path__ + "static/media/error_400.5965b5cd.svg";